/* src/app/components/accessdenied/accessdenied.component.scss */
/*# sourceMappingURL=accessdenied.component.css.map */
